var render = function render(){var _vm=this,_c=_vm._self._c;return _c('uiModal',{attrs:{"title":_vm.docName,"icon":"fal fa-file-word","name":_vm.name,"size":"lg"}},[_c('div',{staticClass:"doc-container"},[_c('iframe',{attrs:{"id":_vm.idIframe,"src":_vm.docUrl,"frameborder":"0"}}),_c('div',{staticClass:"hide"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }